import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";

/**
 * ActionDialog Component
 *
 * A flexible dialog for confirmations and loading states
 *
 * @param {boolean} open - Controls dialog visibility
 * @param {function} onClose - Called when dialog should close
 * @param {function} onConfirm - Called when user confirms (confirm mode only)
 * @param {"confirm" | "loading"} mode - Dialog mode
 * @param {string} title - Dialog title
 * @param {string} confirmText - Confirm button text (default: "Confirm")
 * @param {string} cancelText - Cancel button text (default: "Cancel")
 */
const ActionDialog = ({
  open,
  onClose,
  onConfirm,
  mode = "confirm",
  title,
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  const isLoading = mode === "loading";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ style: { borderRadius: 8 } }}
    >
      {!isLoading && <DialogTitle>{title}</DialogTitle>}

      <DialogContent>
        {isLoading ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="150px"
            gap={2}
          >
            <CircularProgress size={60} />
          </Box>
        ) : null}
      </DialogContent>

      {!isLoading && (
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={onClose} variant="outlined">
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            sx={{
              backgroundColor: "#d32f2f",
              color: "#fff",
              "&:hover": { backgroundColor: "#9a0007" },
            }}
          >
            {confirmText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default ActionDialog;
